import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

import { ProfileCompletionSectionComponent } from '../profile-completion/profile-completetion-section/profile-completion-section.component';
import { ProfileCompletionComponent } from '../profile-completion/profile-completion.component';

@NgModule({
	imports: [CommonModule, FontAwesomeModule, TranslateModule],
	declarations: [ProfileCompletionComponent, ProfileCompletionSectionComponent],
	exports: [ProfileCompletionComponent, ProfileCompletionSectionComponent],
	providers: [],
})
export class ProfileCompletionModule {}
